/**
 * Non-secret fingerprint for logs (~first and last 4 characters). Never log full tokens.
 */
export function threekitTokenPreview(token: string | null | undefined): string {
  const t = (token ?? "").trim();
  if (t.length === 0) return "(empty)";
  if (t.length <= 8) return `(len ${t.length}, redacted)`;
  /* ASCII "..." — safe in HTTP headers (nginx / Latin-1 handling mojibakes U+2026 …) */
  return `${t.slice(0, 4)}...${t.slice(-4)}`;
}
